<template>
  <div class="maintenance">
    <div class="content-wrapper">
      <div class="maintenance-info">
        <i class="fas fa-tools maintenance-icon"></i>
        <h2>Wartungsarbeiten</h2>
        <p>
          Unser Online-Uhren&Schmuck-Service ist aktuell aufgrund von Wartungsarbeiten nicht erreichbar.<br />
          Wir arbeiten mit Hochdruck daran, den Service schnellstmöglich wieder für Sie bereitzustellen.<br />
          <b>Bitte versuchen Sie es in Kürze erneut.</b>
        </p>
        <p class="maintenance-contact">
          Bei dringenden Anliegen wenden Sie sich gern an unsere
          <a href="https://www.christ.de/store-finder#filialsuche" target="_blank" rel="noopener noreferrer">Fachgeschäfte vor Ort</a>.
          <!-- oder unseren <a href="https://www.christ.de/kundenservice/contact" target="_blank" rel="noopener noreferrer">Kundenservice</a>
          (kostenlose Hotline: 0800 1863 300). -->
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Wartungsmodus'
}
</script>
